import * as R from 'ramda'
import * as fecha from 'fecha'


export function string_to_readable(dateString) {
    return R.compose(

        // ggf. Defaultwert
        R.defaultTo('N/A'),

        // Datum parsen
        R.cond([

            // Wenn `ASAP`
            [R.equals('ASAP'), R.always('ASAP')],

            // Wenn `TBA`
            [R.equals('TBA'), R.always('TBA')],

            // Ansonsten wohl date
            [R.T, to_ddmmyyyy],
        ])

    )(dateString)
}

export function to_ddmmyyyy(date) {
    return R.compose(

        // In Format bringen
        R.tryCatch(
            date => fecha.format(date, 'DD.MM.YYYY'),
            R.always(null)
        ),

        // ggf. in Date-Objekt parsen
        R.cond([
            [R.is(String), Date.parse],
            [R.T,          R.identity],
        ])

    )(date)
}

export function to_hhmm(date) {
    return R.compose(

        // In Format bringen
        R.tryCatch(
            date => fecha.format(date, 'HH:mm'),
            R.always(null)
        ),

        // ggf. in Date-Objekt parsen
        R.cond([
            [R.is(String), Date.parse],
            [R.T,          R.identity],
        ])

    )(date)
}

export function to_yyyymmddd(date) {
    return R.tryCatch(
        date => fecha.format(date, 'YYYY-MM-DD'),
        R.always(null)
    )(date)
}
